import { render, staticRenderFns } from "./attributeForm.vue?vue&type=template&id=4a5dc39c"
import script from "./attributeForm.vue?vue&type=script&lang=js"
export * from "./attributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports